import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ExpandIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" fill="none" title={t`Expand`} {...props}>
    <Path
      d="M9 3H3v6m12-6h6v6M3 15v6h6m12-6v6h-6"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
